/**
 * アプリ全体で共有する fiat currency 定義を提供する。
 * 一覧本体と id 一覧の両方を同じ定義源から export する。
 */
import type { FiatCurrency } from '@0xtorch/core'
import { eur, idr, jpy, sgd, usd } from '@0xtorch/core'

/** 利用可能な fiat currency 一覧。 */
export const fiatCurrencies: readonly FiatCurrency[] = [usd, jpy, eur, sgd, idr]

/** 利用可能な fiat currency id 一覧。 */
export const fiatCurrencyIds = fiatCurrencies.map(({ id }) => id)
